import { DynamicAttributeFieldList } from "@/shared/dynamic-attributes/ui/dynamic-attribute-field-list/dynamic-attribute-field-list";
import { FilterContainerWrapper } from "@/shared/filters/ui/containers/with-primary/with-primary-filter";
import { ResetFilterButton } from "./reset-filter-button";
import { useFilterMeta } from "../model/use-filter-meta";
import { useMetaFilterConfig } from "../model/meta-filter-config";

export function OnlyOther() {
  const meta = useFilterMeta();
  const config = useMetaFilterConfig();

  if (!config?.primary) {
    return null;
  }

  return (
    <>
      <DynamicAttributeFieldList name="filters" meta={meta}>
        {(meta, { getNameByAttributeCode }) => (
          <FilterContainerWrapper>
            <>
              {meta.attributes.map((attributeMeta) => (
                <DynamicAttributeFieldList.FormItem
                  key={attributeMeta.id}
                  label={attributeMeta.name.value}
                  layout="vertical"
                  name={getNameByAttributeCode(attributeMeta.attributeCode)}
                  hidden={attributeMeta.attributeCode === config?.primary}
                >
                  <DynamicAttributeFieldList.Item
                    attributeMeta={attributeMeta}
                  />
                </DynamicAttributeFieldList.FormItem>
              ))}
              {meta.groups.map((group) => (
                <>
                  {group.attributes.map((attr) => (
                    <DynamicAttributeFieldList.FormItem
                      key={attr.id}
                      label={attr.name.value}
                      layout="vertical"
                      name={getNameByAttributeCode(attr.attributeCode)}
                      hidden={attr.attributeCode === config?.primary}
                    >
                      <DynamicAttributeFieldList.Item attributeMeta={attr} />
                    </DynamicAttributeFieldList.FormItem>
                  ))}
                </>
              ))}
            </>
            <div className="flex justify-end mt-4">
              <ResetFilterButton />
            </div>
          </FilterContainerWrapper>
        )}
      </DynamicAttributeFieldList>
    </>
  );
}
